/**
 * Orka V3 — Intent vocabulary (PRD §6.3 + Code Reference §3.4).
 *
 * Intent describes WHAT a component helps the user DO.
 * Not a colour variant; influences copy, action order, visual tone, disclosure defaults.
 */
export const INTENT_META = Object.freeze({
  capture:   { key: 'capture',   label: 'Capture',   color: '#64748b', soft: '#64748b22' },
  focus:     { key: 'focus',     label: 'Focus',     color: '#0ea5e9', soft: '#0ea5e922' },
  plan:      { key: 'plan',      label: 'Plan',      color: '#6366f1', soft: '#6366f122' },
  commit:    { key: 'commit',    label: 'Commit',    color: '#059669', soft: '#05966922' },
  recover:   { key: 'recover',   label: 'Recover',   color: '#d97706', soft: '#d9770622' },
  warn:      { key: 'warn',      label: 'Warn',      color: '#dc2626', soft: '#dc262622' },
  reflect:   { key: 'reflect',   label: 'Reflect',   color: '#8b5cf6', soft: '#8b5cf622' },
  delegate:  { key: 'delegate',  label: 'Delegate',  color: '#0f766e', soft: '#0f766e22' },
  automate:  { key: 'automate',  label: 'Automate',  color: '#2563eb', soft: '#2563eb22' },
  private:   { key: 'private',   label: 'Private',   color: '#7c3aed', soft: '#7c3aed22' },
  system:    { key: 'system',    label: 'System',    color: '#2563eb', soft: '#2563eb22' },
});

export const INTENT_KEYS = Object.freeze(Object.keys(INTENT_META));

export function getIntent(key) {
  return INTENT_META[key] || INTENT_META.capture;
}
